import styled from "styled-components";
import { COLORS, responsive } from "../../styles/constants.style";

export const ViewProgramTemplateWrapper = styled.div`
  padding-top: 6px;
  color: ${COLORS.cirrus_black};
  .MuiAccordionSummary-root {
    padding: 0px;
    margin: 0px;
    padding-right: 28px;
  }

  .separator-space {
    margin: 16px 0px;
  }

  .Mui-expanded {
    .MuiAccordionSummary-root {
      margin: 0px;
      background: ${COLORS.primary_light_blue2};
    }
  }
  .MuiAccordionSummary-root {
    background: ${COLORS.primary_light_blue2};
  }

  .MuiAccordionSummary-content {
    margin: 0px;
  }

  .header-collapse {
    display: flex;
    align-items: center;
    justify-content: flex-end;
  }

  .MuiTextField-root > p.MuiFormHelperText-root {
    display: none;
  }

  .table-container {
    margin-top: 8px;
  }

  .country-name {
    min-width: 200px;
  }

  .main-container {
    width: 100%;
    padding: 0 8px 16px 16px;
    ${responsive.TABLET_PORTRAIT`
      padding: 24px 8px;
    `}
    ${responsive.MOBILE`
      padding: 0 8px 16px 8px;
    `}
  }

  .fields-wrapper {
    padding: 16px 16px 16px 0;
    .MuiTypography-root {
      padding-left: 16px;
      padding-bottom: 8px;
    }
    border-top: 1px dashed ${COLORS.primary_light_blue4};
    border-bottom: 1px dashed ${COLORS.primary_light_blue4};
  }
`;
